export default __webpack_public_path__ + "static/media/108.b70c0560.png";